import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/opt/build/repo/www/src/components/mdx/index.tsx";
import { graphql } from 'gatsby';
import { ComponentHeader } from 'components/thumbprint-components';
export const pageQuery = graphql`
    {
        # Get links to by path to display in the navbar.
        platformNav: allSitePage(filter: { path: { glob: "/components/chip/*/" } }) {
            edges {
                node {
                    ...PlatformNavFragment
                }
            }
        }
    }
`;
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  pageQuery,
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <ComponentHeader data={props.data} mdxType="ComponentHeader" />
    <h3>{`Usage`}</h3>
    <p>{`Chips allow users to make selections, filter content, or trigger small actions. Chips should appear as a group of multiple elements in most cases. Unlike buttons, chips shouldn’t navigate away from the current page. If the action requires a new page to load, please use a button instead of a chip.`}</p>
    <h3>{`Components`}</h3>
    <p>{`There are two types of chip components: ToggleChip and FilterChip.`}</p>
    <p>{`A toggle chip behaves the same way as a checkbox and should be used for a set of options where more than one option can be selected.`}</p>
    <p><img parentName="p" {...{
        "src": "/img/ios-toggle-chip.png",
        "alt": "Toggle chip"
      }}></img></p>
    <p>{`A filter chip is meant to behave more like a button and should be used for filtering options.`}</p>
    <p><img parentName="p" {...{
        "src": "/img/ios-filter-chip.png",
        "alt": "Filter chip"
      }}></img></p>
    <p>{`Both types of chips behave the same way to user interaction, they only differ visually and on intended use.`}</p>
    <h2>{`Accessibility`}</h2>
    <p>{`Font size adjustability works the same as for the Pill component.`}</p>
    <p>{`For visually impaired navigation the pill represents itself as a toggle button.`}</p>
    <h2>{`Public API`}</h2>
    <h3>{`Chip`}</h3>
    <p>{`Superclass of both `}<inlineCode parentName="p">{`ToggleChip`}</inlineCode>{` and `}<inlineCode parentName="p">{`FilterChip`}</inlineCode>{`. The subclasses have no additional configuration options.`}</p>
    <h4><inlineCode parentName="h4">{`public var text: String?`}</inlineCode></h4>
    <p>{`While an optional, should always be set to a non-empty string before display.`}</p>
    <h4><inlineCode parentName="h4">{`public var image: UIImage?`}</inlineCode></h4>
    <p>{`If present will always show on the leading side. Should always be a tiny sized icon.`}</p>
    <h3>{`FilterChip`}</h3>
    <p>{`Has no additional configuration options beyond its superclass `}<inlineCode parentName="p">{`Chip`}</inlineCode></p>
    <h3>{`ToggleChip`}</h3>
    <p>{`Has no additional configuration options beyond its superclass `}<inlineCode parentName="p">{`Chip`}</inlineCode></p>


    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      